import React from "react";

import Api from "../../services/Api";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import useAuth from "../../routes/login/AuthContext";
import { HousingMajors } from "../HousingMajors";

export const AcademicMajors = () => {
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { getAuthToken } = useAuth();

  async function handleModify(l2Id: any, oldValue: any, newValue: any, rowId: any) {
    return await Api.requestNewOrEditExistingHousingMajorEntry(
      selectedNetworkId,
      l2Id,
      rowId,
      newValue,
      "majors",
      await getAuthToken()
    );
  }

  async function requestActivationChange(l2Id: any, status: any) {
    return Api.requestActivationChangeHousingMajorEntry(
      selectedNetworkId,
      l2Id,
      status,
      "majors",
      await getAuthToken()
    );
  }

  async function loadMajorsOptions(l2Id: any) {
    return Api.getMajorsOptions(selectedNetworkId, l2Id, await getAuthToken()).then((x) => ({
      active: x.active,
      entries: x.active && x.majors ? x.majors : [],
    }));
  }

  return (
    <HousingMajors
    objectType="Majors"
    handleObjectChange={handleModify}
    handleActivationChange={requestActivationChange}
    loadData={loadMajorsOptions}
    />
  );
};
